import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #15: Reaching the limits of canvas redraw speed",
  "description": "",
  "published": "2016-07-20T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-15-reaching-the-limits-of-canvas-redraw-speed/swizec/6875"],
  "categories": "canvas, coding, Front End, JavaScript, Livecoding, livecoding, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Shorter than 500 words. With pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat ?`}</em></p>
    <p>{`Halp, I need an expert! It looks like we pushed the particle generator to the limits of canvas performance. But that can’t be right, can it? Surely I’m still doing something wrong.`}</p>
    <p><img parentName="p" {...{
        "src": "/d2df88c39e845c0942c86ecb09944d9e/1hECepL.gif",
        "alt": "Pure canvas frame redraw speed"
      }}></img></p>
    <p>{`Pure canvas frame redraw speed`}</p>
    <p>{`We removed everything that could possibly slow us down. There’s no more React or Konva for the main drawing part. All that’s left are the raw HTML5 canvas APIs. Despite our best efforts, it still takes almost 50 milliseconds to draw 10,000 circles.`}</p>
    <p>{`A huge improvement from `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/livecoding-14-mostly-smooth-animation-up-to-4000-elements-with-react-and-canvas/swizec/6864"
      }}>{`last time`}</a>{`, yes. But it’s not good enough. With a drawing time of 50ms per frame, the upper bound on my laptop is about 20 frames per second. Animated, but choppy.`}</p>
    <p>{`And there’s some 5ms of React and Redux overhead on top of that. Down to 18 frames per second.`}</p>
    <p>{`Ugh!`}</p>
    <p>{`The drawing code couldn’t be simpler:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`drawParticle(particle) {
    let { x, y } = particle;

    this.context.beginPath();
    this.context.arc(x, y, 1, 0, 2*Math.PI, false);
    this.context.stroke();
}

componentDidUpdate() {
    let particles = this.props.particles;

    console.time('drawing');
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.context.lineWidth = 1;
    this.context.strokeStyle = 'black';

    for (let i = 0; i < particles.length; i++) {
        this.drawParticle(particles[i]);
    }
    console.timeEnd('drawing');
}
`}</code></pre>
    <p>{`Even profiling confirms that drawing has become the slow part:`}</p>
    <p><img parentName="p" {...{
        "src": "/13cd041122832ddcde55add45f1c1cfa/gNnlJjf.gif",
        "alt": "Profiling shows canvas operations are the bottleneck"
      }}></img></p>
    <p>{`Profiling shows canvas operations are the bottleneck`}</p>
    <p>{`I am at a loss. What else is there to try? There’s no lower layer of abstraction to drop to. Canvas is the bottom. It’s the last in the chain.`}</p>
    <p>{`Well … there’s always manual bitmaps and those base64-encoded strings for images. If you knew how to manipulate those directly, you could trick the browser … no, that’s a silly idea. We’re not doing that. That’s crazy talk.`}</p>
    <p>{`A friend suggested drawing a single circle in an off-screen canvas, then using `}<inlineCode parentName="p">{`drawImage`}</inlineCode>{` to copy-paste it around. But we tried that with Konva, and it didn’t quite work. Maybe it was a Konva problem, and it’s going to work better if we do it ourselves.`}</p>
    <p>{`I dunno. It `}<em parentName="p">{`does`}</em>{` look like `}<inlineCode parentName="p">{`stroke`}</inlineCode>{` and `}<inlineCode parentName="p">{`arc`}</inlineCode>{` are the biggest bottlenecks in `}<inlineCode parentName="p">{`drawCircle`}</inlineCode>{`. Sprites might help.`}</p>
    <p>{`Oh, another optimization that we made was to give Konva more context about what’s going on. Disable most transformations with `}<inlineCode parentName="p">{`transformsEnabled = 'position'`}</inlineCode>{` on all shapes, and set `}<inlineCode parentName="p">{`listening = false`}</inlineCode>{`. That way it knows not to try scale/rotation transformations, and not to listen for events.`}</p>
    <p>{`It helped a bit, but not as much as going to the bare metal for the key drawing part.`}</p>
    <p>{`Next time, we’ll try the `}<inlineCode parentName="p">{`drawImage`}</inlineCode>{` approach, and if that doesn’t work, we’re going to start exploring WebGL. If that can’t do it, nothing can.`}</p>
    <p>{`Are you a canvas expert? Please help. What am I doing wrong?`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.github.io/react-particles-experiment/"
      }}>{`Try the particle generator`}</a>{`.`}</p>
    <p>{`PS: the edited and improved versions of these videos are becoming a video course. Readers of the engineer package of `}<a parentName="p" {...{
        "href": "http://swizec.com/reactd3js/"
      }}>{`React+d3js ES6`}</a>{` get the video course for free when it’s ready.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      